import axios from 'axios';
import {
  IonTitle,
  IonButtons,
  IonButton,
  IonSpinner,
  IonIcon,
} from '@ionic/react';
import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Backdrop from '@material-ui/core/Backdrop';
import { IonPopover } from '@ionic/react';
import { IonImg, IonList, IonItem, IonLabel } from '@ionic/react';
import KeyboardArrowDown from '@material-ui/icons/ExpandMore';
import {
  AppBar,
  BottomNavigation,
  BottomNavigationAction,
  Button,
  Drawer,
  Popover,
  Toolbar,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moonIcon from '../../assets/images/common/icons/moon.svg';
import './Header.scss';
import Modal from '../Modal/Modal';
import LoginForm from '../LoginForm/LoginForm';
import { RootState } from '../../models/RootState';
import {
  fetchBalance,
  logout,
  toggleDarkMode,
  fetchBettingCurrency,
  setEventType,
} from '../../store';
import {
  CASINO_USER_PROFILE_NAV_LIST,
  PROFILE_NAV_LIST,
} from '../../constants/DrawerItems';
import {
  getCurrencyTypeFromToken,
  getRoleFromToken,
  setOpenDepositModal,
  setOpenWithdrawModal,
} from '../../store/auth/authActions';
import webtitleImg from '../../assets/images/brand/title.png';
import mobtitleImg from '../../assets/images/brand/title.png';
import { AuthResponse } from '../../models/api/AuthResponse';
import API from '../../api/index';
import { Currency } from '../../models/Currency';
import BetsListPopper from '../BetsListPopper/BetsListPopper';
import moment from 'moment';
import { useInterval } from '../../hooks/useInterval';
import MenuIcon from '@material-ui/icons/Menu';
import {
  EXCHANGE_EVENT_TYPES,
  EXCH_SPORTS_MAP,
} from '../../constants/ExchangeEventTypes';
import userAvatar from '../../assets/images/img_avatar.png';
import WalletImg from '../../assets/images/icons/wallet.png';
import { SelectedObj } from '../../models/ExchangeSportsState';
import ChangePwdForm from '../ChangePassword/ChangePassword';
import SelectSearch from 'react-select-search';
import {
  demoUserPrefix,
  getSportIdByName,
  themesList,
} from '../../util/stringUtil';
import { isMobile } from 'react-device-detect';
import { ALLOW_CASINO } from '../../constants/CasinoPermission';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import sidebarMobIcon from '../../assets/images/icons/mobSidebarIcon.svg';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { BRAND_NAME, PROVIDER_ID } from '../../constants/Branding';
import { DomainConfig } from '../../models/DomainConfig';
import WhatsupImg from '../../assets/images/footer/whatsup-flot.png';
import SVLS_API from '../../svls-api';
import { BRAND_DOMAIN } from '../../constants/Branding';
import { CloseOutlined, Height } from '@material-ui/icons';
import ButtonVariables from '../ButtonVariables/ButtonVariables';
import Withdrawal from '../../pages/Payment/Withdrawal';
import Deposit from '../../pages/Payment/Deposit';
import AGPAY_API from '../../api-services/feature-api';
import Telegram from '../../assets/images/footer/Telegram.svg';
import { useDomainConfigHook } from '../../hooks/domainConfigHook';
import { checkForDomainConfig } from '../../util/domainConfigUtils';
// import { defaultLang, getLang, getLangCode } from '../../util/localizationUtil';
import {
  setAlertMsg,
  setLangData,
  setLangSelected,
  setLanguages,
} from '../../store/common/commonActions';
import LANG_API from '../../models/api/language-api';
// import { AlertDTO } from '../../models/Alert';
// import defaultLangData from '../../../src/locales/default-lang.json'
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SideHeader from '../SideHeader/SideHeader';
import { getLangCode } from '../../util/localizationUtil';
import { AlertDTO } from '../../models/Alert';
import banksvg from '../../assets/images/banksvg.svg';
type StoreProps = {
  balance: number;
  exposure: number;
  bonus: number;
  allowedConfig: number;
  commissionEnabled: boolean;
  fetchBalance: Function;
  loggedIn: boolean;
  logout: Function;
  fetchBettingCurrency: Function;
  bettingCurrency: Currency;
  currenciesAllowed: number;
  tvGamesEnabled: boolean;
  setEventType: (eventTypes: SelectedObj) => void;
  openDepositModal: boolean;
  openWithdrawModal: boolean;
  setOpenDepositModal: Function;
  setOpenWithdrawModal: Function;
  contentConfig: any;
  domainConfig: DomainConfig;
  languages: string[];
  langSelected: string;
  setLangSelected: (lang: string) => void;
  langData: any;
  toggleDarkMode: (val: string) => void;
};

type options = [{ name: string; value: string }];

const Header: React.FC<StoreProps> = (props) => {
  const [showAdditionalButtons, setShowAdditionalButtons] = useState(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const history = useHistory();
  const [modalTitle, setModalTitle] = useState('Login');
  const [username, setUsername] = useState<string>('');
  const [searchName, setSearchName] = useState<string>('');
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [eventsList, setEventsList] = useState<options>(null);
  const [showPopover, setShowPopover] = useState<{
    open: boolean;
    event: Event | undefined;
  }>({
    open: false,
    event: undefined,
  });
  const [showsPopover, setShowsPopover] = useState<{
    open: boolean;
    event: HTMLElement | undefined;
  }>({
    open: false,
    event: undefined,
  });
  const [showBetsListPopover, setShowBetsListPopover] = useState<{
    open: boolean;
    event: HTMLElement | undefined;
  }>({
    open: false,
    event: undefined,
  });
  const [localTime, setLocalTime] = useState(moment().format('hh:mm:ss A'));
  const {
    balance,
    exposure,
    bonus,
    allowedConfig,
    fetchBalance,
    loggedIn,
    logout,
    fetchBettingCurrency,
    bettingCurrency,
    currenciesAllowed,
    openDepositModal,
    openWithdrawModal,
    setOpenDepositModal,
    setOpenWithdrawModal,
    tvGamesEnabled,
    commissionEnabled,
    setEventType,
    contentConfig,
    domainConfig,
    languages,
    toggleDarkMode,
    langSelected,
    setLangSelected,
    langData,
  } = props;

  const loggedInUsername = sessionStorage.getItem('username');
  const [pointsType, setPointsType] = useState<Currency>();
  const [changePwdMOdal, setChangePwdMOdal] = useState<boolean>(false);
  const [buttonVariablesModal, setButtonVariablesModal] = useState(false);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const [showDeposit, setShowDeposit] = useState<boolean>(true);
  const [showWithdrawal, setShowWithdrawal] = useState<boolean>(true);
  const { showSportsComponents, showCasinoComponents } = useDomainConfigHook();
  const excheventsList = EXCHANGE_EVENT_TYPES;
  const location = useLocation();
  const [adminWhatsAppNumber, setAmdinWhatsAppNumber] = useState<string>();
  // const lang = getLang(sessionStorage?.getItem('lang'));
  const [showNewPotal, setShowNewPotal] = useState<{
    open: boolean;
    event: HTMLElement | undefined;
  }>({
    open: false,
    event: undefined,
  });
  const handleLangChange = (langParam: string) => {
    // console.log(langParam)
    sessionStorage.setItem('lang', langParam);
    setLangSelected(sessionStorage.getItem('lang'));
    window.location.reload();
  };
  const handleButtonClick = () => {
    setShowAdditionalButtons(false);
  };
  const [themeModalOpen, setThemeModalOpen] = useState<{
    open: boolean;
    event: HTMLElement | undefined;
  }>({
    open: false,
    event: undefined,
  });

  const [headers, setHeaders] = useState<any>([
    {
      name: 'In Play',
      langKey: 'in_play',
      className: 'active in-play-active',
      redirectionUrl: '/exchange_sports/inplay',
      config: CONFIG_PERMISSIONS.sports,
      disable: false,
      priority: 0,
    },
    {
      name: 'Exchange',
      langKey: 'exchange',
      className: 'active cricket-active',
      redirectionUrl: '/exchange_sports/cricket',
      config: CONFIG_PERMISSIONS.sports,
      disable: false,
      priority: 1,
    },
    {
      name: 'Sportsbook',
      langKey: 'sports_book',
      className: 'active live-casino-active',
      redirectionUrl: '/premium_sports',
      config: CONFIG_PERMISSIONS.sports,
      disable: false,
      priority: 2,
    },
    {
      name: 'Live Casino',
      langKey: 'live_casino',
      className: 'active live-casino-active',
      redirectionUrl: '/casino',
      config: CONFIG_PERMISSIONS.live_casino,
      disable: false,
      priority: 3,
    },
    // {
    //   name: 'Check Bonuses',
    //   className: 'active live-casino-active',
    //   redirectionUrl: '/profile/bonus',
    //   config: CONFIG_PERMISSIONS.live_casino,
    //   disable: false,
    //   priority: 4,
    // },
  ]);

  const setThemeHandler = (data) => {
    localStorage.setItem('userTheme', data);
    toggleDarkMode(data);
  };

  useEffect(() => {
    var headersArray = headers;
    contentConfig?.headers.forEach((header) => {
      var defaultHeader = headersArray.filter(
        (item) => item.name.toLowerCase() === header.name.toLowerCase()
      )[0];
      if (defaultHeader) {
        defaultHeader.disable = header.disabled;
        defaultHeader.priority = header.priority;
      }
    });
    headersArray.sort((a, b) => a.priority - b.priority);
    setHeaders([...headersArray.filter((elem) => !elem.disable)]);
  }, [contentConfig]);

  useEffect(() => {
    if (loggedIn) {
      fetchBalance();
      fetchBettingCurrency();
    }
  }, [fetchBalance, loggedIn, fetchBettingCurrency]);

  useEffect(() => {
    toggleDarkMode(localStorage.getItem('userTheme'));
  }, []);
  useEffect(() => {
    setEventsList(null);
    setShowSearch(false);
    setUsername('');
    setSearchName('');
  }, [location]);

  const popoverDismissHandler = () => {
    setShowPopover({ open: false, event: undefined });
    setShowNewPotal({
      open: false,
      event: undefined,
    });
    setThemeModalOpen({ open: false, event: undefined });
  };

  useInterval(() => {
    if (loggedIn) {
      setLocalTime(moment().format('hh:mm:ss A'));
    }
  }, 1000);

  const loginHandler = () => {
    history.push('/login');
    // setModalOpen(true);
    // setModalTitle('Login');
    // setShowPopover({ open: false, event: undefined });
  };
  const toggleButtons = () => {
    setShowAdditionalButtons(!showAdditionalButtons);
  };
  const changeBettingCurrency = useCallback(
    async (currency: Currency) => {
      try {
        const response: AuthResponse = await API.put(
          '/user/betting-currency',
          { currency: currency },
          {
            headers: {
              Authorization: sessionStorage.getItem('jwt_token'),
            },
            responseType: 'text',
          }
        );
        if (response.status === 200) {
          fetchBettingCurrency();
          fetchBalance();
        } else {
          throw new Error(response.data);
        }
      } catch (err) {}
    },
    [fetchBalance, fetchBettingCurrency]
  );

  useEffect(() => {
    getAdminWhatsAppNumber();
  }, []);

  const getAdminWhatsAppNumber = async () => {
    try {
      let response;
      let whatsappDetails;
      let url;
      if (loggedIn) {
        response = await SVLS_API.get(
          `/account/v2/books/${BRAND_DOMAIN}/contact-list`,
          {
            headers: {
              Authorization: sessionStorage.getItem('jwt_token'),
            },
          }
        );
        if (response.status === 200) {
          whatsappDetails = response.data.filter((contact) => {
            return contact?.contactType == 'REGISTRATION_WHATSAPP_LINK';
          });
          url = whatsappDetails[0].details;
        }
      } else {
        response = await SVLS_API.get(
          `/account/v2/books/${BRAND_DOMAIN}/sdm-contact`
        );
        if (response.status === 200) {
          let whatsappDetails = response.data.filter((contact) => {
            return contact?.contactType == 'WHATSAPP_NUMBER';
          });
          url = `http://api.whatsapp.com/send?phone=${whatsappDetails[0]?.details}`;
        }
      }
      if (response.status === 200) {
        setAmdinWhatsAppNumber(whatsappDetails[0]?.details);
        const a = document.getElementById('link');
        const sikanderSignUp = document.getElementById('link-sikander');
        a.setAttribute('href', url);
        a.setAttribute('target', '_blank');
        sikanderSignUp.setAttribute('href', url);
        sikanderSignUp.setAttribute('target', '_blank');
      }
    } catch (err) {}
  };

  const handleSideBarIconClick = () => {
    setOpenDrawer(true);
  };

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  const handlePopoverClose = () => {
    setShowPopover({ open: false, event: undefined });
  };

  const logoutHandler = () => {
    logout();
    setShowPopover({ open: false, event: undefined });
  };

  // const popoverDismissHandler = () => {
  //   setShowPopover({ open: false, event: undefined });
  // };

  const searchHandler = async (query: string) => {
    const from = moment();
    const toDate = moment().add(2, 'd');
    const url = '/catalog/v2/sports-feed/sports/live-events:search';

    const params = {
      searchString: searchName.toLowerCase(),
      startDate: from.startOf('day').toISOString(),
      endDate: toDate.startOf('day').toISOString(),
    };
    let response;
    if (sessionStorage.getItem('jwt_token')) {
      response = await SVLS_API.get(url, {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        params: {
          providerId: PROVIDER_ID,
          query: query,
        },
      });
    } else {
      response = await API.post(
        url,
        {},
        {
          params: params,
        }
      );
    }

    let newOps: options = [{ name: '', value: '' }];
    newOps.pop();
    response.data.map((m) =>
      newOps.push({
        name: m.eventName,
        value: `${m.sportId}*${m.eventId}*${m.eventName}*${m.competitionId}*${m.competitionName}`,
      })
    );

    setEventsList(newOps);
  };

  const getPaymentProviders = async () => {
    const accountId = sessionStorage.getItem('aid');
    try {
      const response = await AGPAY_API.get(
        `/agpay/v2/payment-settings/accounts/${accountId}`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
            'Content-Type': 'application/json',
          },
        }
      );
      if (response.status === 200) {
        if (
          response?.data?.withdraw_provider_list &&
          response?.data?.withdraw_provider_list?.length > 0
        ) {
          setShowWithdrawal(true);
        } else {
          setShowWithdrawal(false);
        }

        if (
          response?.data?.deposit_provider_list &&
          response?.data?.deposit_provider_list?.length > 0
        ) {
          setShowDeposit(true);
        } else {
          setShowDeposit(false);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (searchName.length > 2) {
      searchHandler(searchName);
    }
  }, [searchName]);

  useEffect(() => {
    if (loggedIn) {
      getPaymentProviders();
    }
  }, []);

  const handleEventSearch = (e: any) => {
    console.log(e);
    setUsername(e.toString());
    let urlInfo = e.split('*');

    const competitionSlug = urlInfo[4]
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]/g, ' ')
      .replace(/ +/g, ' ')
      .trim()
      .split(' ')
      .join('-');

    const eventSlug = urlInfo[2]
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]/g, ' ')
      .replace(/ +/g, ' ')
      .trim()
      .split(' ')
      .join('-');

    history.push(
      `/exchange_sports/${urlInfo[0]}/${competitionSlug}/${eventSlug}/${btoa(
        `${getSportIdByName(urlInfo[0].toLowerCase())}:${urlInfo[3]}:${
          urlInfo[1]
        }`
      )}`
    );

    // reset search control
    setEventsList(null);
    setShowSearch(false);
    setUsername('');
    setSearchName('');
  };
  const signupHandler = () => {
    history.push('/register');
  };

  const defaultHeaders = headers.map((value) => {
    return checkForDomainConfig(
      value.config,
      showSportsComponents,
      showCasinoComponents
    ) ? (
      <NavLink
        activeClassName={value.className}
        to={value.redirectionUrl}
        className="nav-link"
      >
        <IonButton className="nav-link-btn" color="">
          {langData?.[value.langKey]}
        </IonButton>
      </NavLink>
    ) : null;
  });

  return (
    <>
      <AppBar
        position="static"
        className={
          history.location.pathname.startsWith('/casino') ||
          (history.location.pathname.startsWith('/poker') && isMobile)
            ? 'hidden-header main-header-ctn ds-view-ctn mob-header-ctn'
            : 'main-header-ctn ds-view-ctn mob-header-ctn'
        }
      >
        <Toolbar className="header-toolbar">
          <div className="tool-bar-content">
            <div className="side-bar-icon-div mob-view">
              <MenuIcon onClick={handleSideBarIconClick} />

              <IonButtons slot="start">
                <IonTitle
                  class="icon-title"
                  slot="start"
                  size="small"
                  onClick={() => history.push('/home')}
                >
                  <IonImg className="web-logo web-view" src={webtitleImg} />
                  <IonImg className="mob-logo mob-view" src={mobtitleImg} />
                </IonTitle>
                {/* {loggedIn ? (
                <div className="live-clock">
                  <div className="date">{moment().format('MMM D, YYYY')}</div>
                  <div className="time">{localTime}</div>
                </div>
              ) : null} */}
              </IonButtons>
            </div>
            <IonButtons slot="start">
              <IonTitle
                class="icon-title"
                slot="start"
                size="small"
                onClick={() => history.push('/home')}
              >
                <IonImg className="web-logo web-view" src={webtitleImg} />
              </IonTitle>
            </IonButtons>
            {domainConfig.isDomainConfigLoading ? (
              <div className="loader-div">
                <IonSpinner className="loading-page-spinner" name="bubbles" />
              </div>
            ) : (
              <IonButtons
                className={`nav-btns ${
                  loggedIn &&
                  getRoleFromToken() &&
                  getRoleFromToken() !== 'User'
                    ? 'admin-header'
                    : ''
                }`}
              >
                {defaultHeaders}
              </IonButtons>
            )}

            {loggedIn && showSearch ? (
              <div className="event-search search-col">
                <SelectSearch
                  search
                  getOptions={(query) => {
                    return new Promise((resolve, reject) => {
                      setSearchName(query);
                    });
                  }}
                  onChange={(e) => handleEventSearch(e)}
                  placeholder="Search event"
                  options={eventsList}
                  value={searchName}
                ></SelectSearch>

                <span
                  className="clear-search"
                  onClick={() => {
                    setUsername('');
                    setSearchName('');
                    setShowSearch(false);
                  }}
                >
                  <CloseIcon className="close-icon m-link" />
                </span>
              </div>
            ) : null}

            <IonButtons className="right-side-actions" slot="end">
              {loggedInUsername?.startsWith(demoUserPrefix) ? null : (
                <>
                  {loggedIn && domainConfig.signup ? (
                    <div className="circle-button-container">
                      {/* Main circle button */}
                      <IonButton
                        className="circle-button"
                        onClick={toggleButtons}
                        shape="round"
                        color="primary"
                        size="small"
                      >
                        <img
                          loading="lazy"
                          src={banksvg}
                          alt=""
                          className="h-[24px] w-[24px]"
                        />
                      </IonButton>

                      <div>
                        <div
                          className={`additional-buttons ${
                            showAdditionalButtons ? 'show' : ''
                          }`}
                        >
                          {showAdditionalButtons ? (
                            <>
                              {domainConfig.signup && domainConfig.payments ? (
                                <>
                                  {showDeposit ? (
                                    <>
                                      <IonButton
                                        onClick={(e) => {
                                          setOpenDepositModal(true);
                                        }}
                                        id="deposit-button"
                                        className="my-bets-btn actions-btn"
                                        style={{
                                          width: '85px',
                                          height: '32px',
                                          marginLeft: '5px',
                                          marginTop: '20px',
                                          fontWeight: 600,
                                          fontSize: '14px',
                                          color: 'white',
                                        }}
                                      >
                                        {langData?.['deposit']}
                                      </IonButton>
                                      {/* <IonButton
                                      onClick={(e) => {
                                        history.push('/transaction/deposit');
                                      }}
                                      className="my-bets-btn deposit-btn actions-btn mob-view"
                                    >
                                      {langData?.['d']}
                                    </IonButton> */}
                                    </>
                                  ) : null}

                                  {showWithdrawal ? (
                                    <>
                                      <IonButton
                                        onClick={(e) => {
                                          setOpenWithdrawModal(true);
                                          handleButtonClick();
                                        }}
                                        className="my-bets-btn actions-btn"
                                        style={{
                                          width: '85px',
                                          height: '32px',
                                          marginLeft: '5px',
                                          fontWeight: 600,
                                          fontSize: '14px',
                                          color: 'white',
                                        }}
                                      >
                                        {langData?.['withdraw']}
                                      </IonButton>

                                      {/* <IonButton
                                      onClick={(e) => {
                                        setOpenWithdrawModal(true);
                                      }}
                                      className="my-bets-btn withdraw-btn actions-btn mob-view"
                                    >
                                      {langData?.['withdraw']}
                                    </IonButton> */}
                                    </>
                                  ) : null}
                                </>
                              ) : null}

                              {domainConfig.bonus ? (
                                <IonButton
                                  onClick={() => {
                                    history.push('/profile/referral');
                                    handleButtonClick();
                                  }}
                                  className="my-bets-btn actions-btn"
                                  style={{
                                    width: '85px',
                                    height: '32px',
                                    marginLeft: '5px',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    color: 'white',
                                  }}
                                >
                                  {langData?.['referrals']}{' '}
                                </IonButton>
                              ) : null}

                              <IonButton
                                onClick={(e) => {
                                  setShowBetsListPopover({
                                    open: true,
                                    event: e.currentTarget,
                                  });
                                  handleButtonClick();
                                }}
                                className="my-bets-btn actions-btn"
                                style={{
                                  marginLeft: '5px',
                                  height: '32px',
                                  width: '85px',
                                  fontWeight: 600,
                                  fontSize: '14px',
                                  colour: 'white',
                                }}
                              >
                                <div className="btn-content">
                                  <div className="btn-header exposure-details">
                                    {langData?.['my_bets']}
                                  </div>
                                </div>
                              </IonButton>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {domainConfig.whatsapp &&
                  BRAND_NAME.toLocaleLowerCase() !== 'shreejiexch9' ? (
                    <a
                      id="link"
                      className="actions-btn whatsapp-btn"
                      onClick={getAdminWhatsAppNumber}
                    >
                      <div className="btn-content">
                        <img src={WhatsupImg} className="social-icon1" />
                      </div>
                    </a>
                  ) : null}
                  {BRAND_NAME.toLocaleLowerCase() === 'shreejiexch9' ? (
                    <IonButton
                      className="actions-btn whatsapp-btn"
                      onClick={() =>
                        window.open(
                          `http://api.whatsapp.com/send?phone=8534888880`,
                          '_blank'
                        )
                      }
                    >
                      <div className="btn-content">
                        <img src={WhatsupImg} className="social-icon1" />
                      </div>
                    </IonButton>
                  ) : null}
                  {BRAND_NAME.toLocaleLowerCase() === 'faircric' ? (
                    <IonButton className="whatsapp-btn">
                      <div className="btn-content">
                        <a href={`https://t.me/+918200563716`} target="_blank">
                          <img src={Telegram} className="social-icon1" />
                        </a>
                      </div>
                    </IonButton>
                  ) : null}
                </>
              )}
              {loggedIn ? (
                <>
                  {showSearch ? null : (
                    <>
                      {/* {window.location.pathname.includes('exchange_sports') &&
                      !window.location.pathname.endsWith(
                        'exchange_sports/binary'
                      ) ? (
                        <IonButtons
                          className="m-link search-icon-ctn"
                          onClick={() => setShowSearch(true)}
                        >
                          <SearchIcon className="search-icon" />
                        </IonButtons>
                      ) : null} */}

                      {/* {domainConfig.signup && domainConfig.payments ? (
                        <>
                          {showDeposit ? (
                            <>
                              <IonButton
                                onClick={(e) => {
                                  setOpenDepositModal(true);
                                }}
                                id="deposit-button"
                                className="my-bets-btn deposit-btn actions-btn web-view"
                              >
                                {langData?.['deposit']}
                              </IonButton>
                              <IonButton
                                onClick={(e) => {
                                  history.push('/transaction/deposit');
                                }}
                                className="my-bets-btn deposit-btn actions-btn mob-view"
                              >
                                {langData?.['d']}
                              </IonButton>
                            </>
                          ) : null}

                          {showWithdrawal ? (
                            <>
                              <IonButton
                                onClick={(e) => {
                                  setOpenWithdrawModal(true);
                                }}
                                className="my-bets-btn withdraw-btn actions-btn web-view"
                              >
                                {langData?.['withdraw']}
                              </IonButton>

                              <IonButton
                                onClick={(e) => {
                                  history.push('/transaction/withdraw');
                                }}
                                className="my-bets-btn withdraw-btn actions-btn mob-view"
                              >
                                {langData?.['w']}
                              </IonButton>
                            </>
                          ) : null}
                        </>
                      ) : null}
                      <IonButton
                        onClick={(e) => {
                          setShowBetsListPopover({
                            open: true,
                            event: e.currentTarget,
                          });
                        }}
                        className="my-bets-btn actions-btn web-view"
                      >
                        <div className="btn-content">
                          <div className="btn-header exposure-details">
                          {langData?.['my_bets']}
                          </div>
                        </div>
                      </IonButton> */}

                      {!domainConfig.signup ? (
                        <IonButton
                          onClick={(e) => {
                            setShowBetsListPopover({
                              open: true,
                              event: e.currentTarget,
                            });
                          }}
                          className="my-bets-btn actions-btn mob-view"
                          style={{
                            background:
                              'linear-gradient(to left, #B0C4FF, #1d3281)',
                            borderRadius: '8px',
                          }}
                        >
                          <div className="btn-content">
                            <div className="btn-header exposure-details">
                              {langData?.['my_bets']}
                            </div>
                          </div>
                        </IonButton>
                      ) : null}
                      {!domainConfig.signup ? (
                        <IonButton
                          onClick={(e) => {
                            setShowBetsListPopover({
                              open: true,
                              event: e.currentTarget,
                            });
                          }}
                          className="my-bets-btn actions-btn web-view"
                          style={{
                            background:
                              'linear-gradient(to left, #B0C4FF, #1d3281)',
                            borderRadius: '8px',
                          }}
                        >
                          <div className="btn-content">
                            <div className="btn-header exposure-details">
                              {langData?.['my_bets']}
                            </div>
                          </div>
                        </IonButton>
                      ) : null}
                      <div className="balance-details-ctn">
                        <div className="balance-details">
                          {langData?.['header_balance_txt']}:
                          {balance !== null
                            ? Number(balance / cFactor).toFixed(2)
                            : '-.--'}
                        </div>
                        <div>
                          {langData?.['header_exp_txt']}:
                          {exposure !== null
                            ? Number(exposure / cFactor).toFixed(2)
                            : '-.--'}
                        </div>
                      </div>

                      <IonButton
                        className="user-acc-btn actions-btn web-view"
                        onClick={(e) => {
                          if (!isMobile)
                            setShowPopover({
                              open: true,
                              event: e.nativeEvent,
                            });
                          else history.push('/dashboard');
                        }}
                      >
                        <IonImg
                          className="user-avatar"
                          src={userAvatar}
                          alt="user"
                        />
                        <div className="btn-content">
                          {!isMobile && (
                            <div className="btn-header">
                              {loggedInUsername?.startsWith(demoUserPrefix)
                                ? 'Demo User'
                                : loggedInUsername}
                            </div>
                          )}
                          {/* <div className="balance-details web-view">
                          Bal:{' '}
                          {balance !== null
                            ? Number(balance / cFactor).toFixed(2)
                            : '-.--'}
                        </div> */}
                        </div>
                        {isMobile ? null : <KeyboardArrowDown />}
                      </IonButton>

                      <IonButton className="user-acc-btn actions-btn mob-actions-btn">
                        <IonImg
                          className="wallet-icon"
                          src={WalletImg}
                          alt="wallet"
                        />
                        <div
                          className="btn-content-mob"
                          onClick={(e) => {
                            setShowBetsListPopover({
                              open: true,
                              event: e.currentTarget,
                            });
                          }}
                        >
                          {/* <div className="balance-details-mob">
                            Bal: {Number(balance).toFixed(2)}
                          </div> */}
                          <div className="exposure-details-mob">
                            {langData?.['header_exp_txt']}:{' '}
                            {Number(exposure).toFixed(2)}
                          </div>
                        </div>

                        <IonImg
                          onClick={(e) =>
                            setShowPopover({ open: true, event: e.nativeEvent })
                          }
                          className="user-avatar"
                          src={userAvatar}
                          alt="user"
                        />
                        <KeyboardArrowDown
                          onClick={(e) =>
                            setShowPopover({ open: true, event: e.nativeEvent })
                          }
                        />
                      </IonButton>
                    </>
                  )}
                </>
              ) : (
                <>
                  <IonButtons slot="secondary">
                    <IonButton
                      slot="end"
                      className="login-btn"
                      onClick={loginHandler}
                      fill="solid"
                      color="primary"
                    >
                      {langData?.['login']}
                    </IonButton>

                    {domainConfig.signup ? (
                      <IonButton
                        slot="end"
                        id="signup-button-home"
                        className="signup-btn"
                        onClick={signupHandler}
                      >
                        {langData?.['sign_up']}
                      </IonButton>
                    ) : null}
                    {BRAND_NAME.toLocaleLowerCase() === 'sikander247' && (
                      <a
                        id="link-sikander"
                        className="signup-btn"
                        onClick={getAdminWhatsAppNumber}
                      >
                        {langData?.['sign_up']}
                      </a>
                    )}
                  </IonButtons>
                </>
              )}
              <>
                {BRAND_DOMAIN.toLocaleLowerCase()! === 'mazaa.io' ||
                BRAND_DOMAIN.toLocaleLowerCase() === 'hypexexch.com' ? (
                  <div
                    className="switch"
                    onClick={(e) =>
                      setThemeModalOpen({
                        open: true,
                        event: e.currentTarget,
                      })
                    }
                  >
                    <div className="round">
                      <IonIcon src={moonIcon} className="moon-img" />
                    </div>
                  </div>
                ) : null}
              </>
            </IonButtons>
          </div>
        </Toolbar>
      </AppBar>

      <IonPopover
        isOpen={showPopover.open}
        event={showPopover.event}
        mode="ios"
        onDidDismiss={() => popoverDismissHandler()}
        cssClass={
          currenciesAllowed === 2
            ? 'user-menu-popover extra-width'
            : 'user-menu-popover'
        }
      >
        <div className="user-popover">
          <IonList lines="none" class="user-popover-list">
            <NavLink
              activeClassName="active"
              className="nav-link"
              to="/profile"
              onClick={handlePopoverClose}
            >
              <IonItem className="ion-list-item profile-item">
                <div slot="start">
                  <div className="profile-link">
                    {loggedInUsername?.startsWith(demoUserPrefix)
                      ? 'Demo User'
                      : loggedInUsername}
                  </div>
                  <div className="balance">
                    {balance !== null
                      ? parseFloat((balance / cFactor).toString()).toFixed(2)
                      : '-'}
                  </div>
                </div>
                <div slot="end">
                  {currenciesAllowed === 2 ? (
                    <BottomNavigation
                      value={pointsType ? pointsType : bettingCurrency}
                      onChange={(event, newValue) => {
                        changeBettingCurrency(newValue);
                        setPointsType(newValue);
                      }}
                      showLabels
                      className="header-pointstype-toggle"
                    >
                      <BottomNavigationAction
                        label="PTS"
                        value={Currency.Pts}
                      />
                      <BottomNavigationAction
                        label="HKD"
                        value={Currency.Hkd}
                      />
                    </BottomNavigation>
                  ) : null}
                </div>
              </IonItem>
            </NavLink>

            {checkForDomainConfig(
              CONFIG_PERMISSIONS.sports,
              showSportsComponents,
              showCasinoComponents
            ) ? (
              <>
                {PROFILE_NAV_LIST.map((item, index) => (
                  <NavLink
                    activeClassName="active"
                    className="nav-link"
                    to={item.path}
                    key={index}
                    onClick={handlePopoverClose}
                  >
                    <IonItem className="ion-list-item">
                      <IonLabel>{langData?.[item.langKey]}</IonLabel>
                    </IonItem>
                  </NavLink>
                ))}
              </>
            ) : (
              <>
                {CASINO_USER_PROFILE_NAV_LIST.map((item, index) => (
                  <NavLink
                    activeClassName="active"
                    className="nav-link"
                    to={item.path}
                    key={index}
                    onClick={handlePopoverClose}
                  >
                    <IonItem className="ion-list-item">
                      <IonLabel>{langData?.[item.langKey]}</IonLabel>
                    </IonItem>
                  </NavLink>
                ))}
              </>
            )}

            {/* {domainConfig.signup ? (
              <> */}
            {/* <NavLink
                  activeClassName="active"
                  className="nav-link"
                  to="/transaction/deposit"
                >
                  <IonItem className="ion-list-item">
                    <IonLabel>Deposit</IonLabel>
                  </IonItem>
                </NavLink>
                <NavLink
                  activeClassName="active"
                  className="nav-link"
                  to="/transaction/withdraw"
                >
                  <IonItem className="ion-list-item">
                    <IonLabel>Withdrawal</IonLabel>
                  </IonItem>
                </NavLink> */}
            {domainConfig.signup ? (
              <>
                {showWithdrawal || showDeposit ? (
                  <NavLink
                    activeClassName="active"
                    className="nav-link"
                    to="/my_transactions"
                    onClick={handlePopoverClose}
                  >
                    <IonItem className="ion-list-item">
                      <IonLabel>{langData?.['my_txns']}</IonLabel>
                    </IonItem>
                  </NavLink>
                ) : null}

                {showDeposit ? (
                  <IonItem
                    className="ion-list-item"
                    onClick={() => {
                      setOpenDepositModal(true);
                      handlePopoverClose();
                    }}
                  >
                    <IonLabel>{langData?.['deposit']}</IonLabel>
                  </IonItem>
                ) : null}

                {showWithdrawal ? (
                  <IonItem
                    className="ion-list-item"
                    onClick={() => {
                      setOpenWithdrawModal(true);
                      handlePopoverClose();
                    }}
                  >
                    <IonLabel>{langData?.['withdraw']}</IonLabel>
                  </IonItem>
                ) : null}
              </>
            ) : null}

            {/* </>
            ) : null} */}

            {commissionEnabled &&
            checkForDomainConfig(
              CONFIG_PERMISSIONS.sports,
              showSportsComponents,
              showCasinoComponents
            ) ? (
              <NavLink
                activeClassName="active"
                className="nav-link"
                to="/commission_report:upline"
                onClick={handlePopoverClose}
              >
                <IonItem className="ion-list-item">
                  <IonLabel>{langData?.['commission_report']}</IonLabel>
                </IonItem>
              </NavLink>
            ) : null}
            {domainConfig.bonus ? (
              <>
                <NavLink
                  activeClassName="active"
                  className="nav-link"
                  to="/bonus_statement"
                  onClick={handlePopoverClose}
                >
                  <IonItem className="ion-list-item">
                    <IonLabel>{langData?.['bonus_statement']}</IonLabel>
                  </IonItem>
                </NavLink>
                <NavLink
                  activeClassName="active"
                  className="nav-link"
                  to="/bonus/turnover_history"
                  onClick={handlePopoverClose}
                >
                  <IonItem className="ion-list-item">
                    <IonLabel>{langData?.['turnover_history']}</IonLabel>
                  </IonItem>
                </NavLink>
              </>
            ) : null}
            <IonItem
              className="ion-list-item"
              onClick={() => {
                setButtonVariablesModal(true);
                handlePopoverClose();
              }}
            >
              <IonLabel>{langData?.['set_button_variables']}</IonLabel>
            </IonItem>

            {!loggedInUsername?.startsWith(demoUserPrefix) ? (
              <IonItem
                className="ion-list-item"
                onClick={() => {
                  setChangePwdMOdal(true);
                  handlePopoverClose();
                }}
              >
                <IonLabel>{langData?.['change_password_txt']}</IonLabel>
              </IonItem>
            ) : null}
            <IonItem
              className="ion-list-item logout-item"
              onClick={logoutHandler}
            >
              <IonLabel>{langData?.['logout']}</IonLabel>
            </IonItem>
          </IonList>
        </div>
      </IonPopover>
      <Popover
        open={themeModalOpen.open}
        anchorEl={showsPopover.event}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={() => popoverDismissHandler()}
        className="theme-optionslist"
      >
        <div className="theme-drop-down">
          <div className="theme-options">
            {themesList.map((theme, idx) => (
              <span
                className="circle1"
                onClick={(e) => {
                  setThemeHandler(theme);
                  popoverDismissHandler();
                }}
              >
                <span className={`round bg${idx + 1}`}></span>
              </span>
            ))}
          </div>
        </div>
      </Popover>
      <Popover
        open={showBetsListPopover.open}
        anchorEl={showBetsListPopover.event}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        className="bets-list-popover"
        onClose={() => setShowBetsListPopover({ open: false, event: null })}
      >
        <div className="">
          <BetsListPopper
            closePopover={() =>
              setShowBetsListPopover({ open: false, event: null })
            }
          />
        </div>
      </Popover>

      <Backdrop className="backdrop-ctn" open={modalOpen}>
        <Modal
          open={modalOpen}
          closeHandler={modalCloseHandler}
          title={modalTitle}
          size="xl"
          customClass={'login-modal-ctn'}
        >
          <div className="login-border">
            <LoginForm modalCloseHandler={modalCloseHandler}></LoginForm>
          </div>
        </Modal>
      </Backdrop>

      <Backdrop className="backdrop-ctn" open={changePwdMOdal}>
        <Drawer
          anchor={'right'}
          open={changePwdMOdal}
          onClose={() => setChangePwdMOdal(false)}
          className="light-bg-title game-rules-drawer"
          title="Change Password"
          // size="md"
        >
          <div className="game-rules-header">
            <div className="game-rules-title">
              {langData?.['change_password_txt']}
            </div>
            <div
              className="game-rules-close cursor"
              onClick={() => setChangePwdMOdal(false)}
            >
              <CloseOutlined />
            </div>
          </div>
          <ChangePwdForm
            closeHandler={() => setChangePwdMOdal(false)}
            backHandler={() => {}}
          />
        </Drawer>
        <Drawer
          anchor={'right'}
          open={buttonVariablesModal}
          onClose={() => setButtonVariablesModal(false)}
          className="light-bg-title game-rules-drawer"
          // title={langData?.['change_password_txt']}
          // size="md"
        >
          <div className="game-rules-header">
            <div className="game-rules-title">
              {langData?.['set_button_variables']}
            </div>
            <div
              className="game-rules-close cursor"
              onClick={() => setButtonVariablesModal(false)}
            >
              <CloseOutlined />
            </div>
          </div>
          <ButtonVariables
          // closeHandler={() => setButtonVariablesModal(false)}
          // backHandler={() => { }}
          />
        </Drawer>
      </Backdrop>

      <Backdrop className="backdrop-ctn" open={openDepositModal}>
        <Drawer
          anchor={'right'}
          open={openDepositModal}
          onClose={() => setOpenDepositModal(false)}
          className="light-bg-title game-rules-drawer"
          title=""
          // size="md"
        >
          <div className="game-rules-header">
            <div className="game-rules-title">{langData?.['deposit']}</div>
            <div
              className="game-rules-close cursor"
              onClick={() => setOpenDepositModal(false)}
            >
              <CloseOutlined />
            </div>
          </div>
          <Deposit />
        </Drawer>
      </Backdrop>
      <Backdrop className="backdrop-ctn" open={openWithdrawModal}>
        <Drawer
          anchor={'right'}
          open={openWithdrawModal}
          onClose={() => setOpenWithdrawModal(false)}
          className="light-bg-title game-rules-drawer"
          title=""
          // size="md"
        >
          <div className="game-rules-header">
            <div className="game-rules-title">{langData?.['withdraw']}</div>
            <div
              className="game-rules-close cursor"
              onClick={() => setOpenWithdrawModal(false)}
            >
              <CloseOutlined />
            </div>
          </div>
          <Withdrawal />
        </Drawer>
      </Backdrop>
      <Drawer
        anchor={'left'}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <SideHeader closeHandler={() => setOpenDrawer(false)} />
      </Drawer>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
    bonus: state.auth.balanceSummary.bonus,
    allowedConfig: state.common.allowedConfig,
    domainConfig: state.common.domainConfig,
    loggedIn: state.auth.loggedIn,
    commissionEnabled: state.common.commissionEnabled,
    bettingCurrency: state.common.bettingCurrency,
    currenciesAllowed: state.common.currenciesAllowed,
    tvGamesEnabled: state.common.tvGamesEnabled,
    openDepositModal: state.auth.openDepositModal,
    openWithdrawModal: state.auth.openWithdrawModal,
    contentConfig: state.common.contentConfig,
    langSelected: state.common.langSelected,
    languages: state.common.languages,
    langData: state.common.langData,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchBalance: () => dispatch(fetchBalance()),
    logout: () => dispatch(logout()),
    fetchBettingCurrency: () => dispatch(fetchBettingCurrency()),
    setEventType: (et: SelectedObj) => dispatch(setEventType(et)),
    setOpenDepositModal: (val) => dispatch(setOpenDepositModal(val)),
    setOpenWithdrawModal: (val) => dispatch(setOpenWithdrawModal(val)),
    setLangSelected: (lang: string) => dispatch(setLangSelected(lang)),
    setLanguages: (languages: string[]) => dispatch(setLanguages(languages)),
    setLangData: (langData: any) => dispatch(setLangData(langData)),
    setAlertMsg: (alert: AlertDTO) => dispatch(setAlertMsg(alert)),
    toggleDarkMode: (val: string) => dispatch(toggleDarkMode(val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
